<template>
<div id="puzzles">
  <h2>Puzzles</h2>

  <puzzle-nav />

  <div class="text-center">
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <label class="btn btn-primary active" v-on:click="showFilter">
        <input type="radio" name="filter" id="option0" autocomplete="off" value="" v-model="filter" checked> All Puzzles
      </label>
      <label class="btn btn-primary" v-on:click="showFilter">
        <input type="radio" name="filter" id="option1" autocomplete="off" value="date" v-model="filter"> By Date
      </label>
      <label class="btn btn-primary" v-on:click="showFilter">
        <input type="radio" name="filter" id="option2" autocomplete="off" value="year" v-model="filter"> By Year
      </label>
      <label class="btn btn-primary" v-on:click="showFilter">
        <input type="radio" name="filter" id="option3" autocomplete="off" value="type" v-model="filter"> By Type
      </label>
    </div>
  </div>

  <hr />

  <puzzle-calendar v-if="filter === 'date'"/>

  <puzzles-by-year v-if="filter === 'year'" />

  <provider-picker
    label="Get By Puzzle Type"
    v-if="filter === 'type'"
  />

  <pagination
    :resourceUrl="puzzlesUrl"
    :pageSize="$root.defaultPageSize"
    orderBy="date"
    orderType="DESC"
    v-if="showPagination"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <puzzle-list :puzzle="item" />
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import ProviderPicker from '@/components/ProviderPicker'
import PuzzleCalendar from '@/components/PuzzleCalendar'
import PuzzleListItem from '@/components/PuzzleListItem'
import PuzzleNav from '@/components/PuzzleNav'
import PuzzlesByYear from '@/components/PuzzlesByYear'

import PuzzlesStore from '@/stores/PuzzlesStore'

export default {
  data: function () {
    let state = PuzzlesStore.state
    state.byDate = false
    state.byYear = false
    state.byType = false
    state.filter = undefined
    state.defaultPuzzlesUrl = undefined
    state.puzzlesUrl = state.defaultPuzzlesUrl

    return state
  },

  components: {
    pagination: Pagination,
    'provider-picker': ProviderPicker,
    'puzzle-calendar': PuzzleCalendar,
    'puzzle-list': PuzzleListItem,
    'puzzle-nav': PuzzleNav,
    'puzzles-by-year': PuzzlesByYear
  },

  computed: {
    showPagination () {
      return !this.filter || this.filter === 'type'
    }
  },

  created () {
    this.setUrl()
    this.$on('providerSelected', this.getProviderPuzzles)
  },

  methods: {
    getProviderPuzzles (provider) {
      this.puzzlesUrl = this.apiUrl('/providers/' + provider.id + '/puzzles', true)
    },

    setUrl () {
      this.defaultPuzzlesUrl = this.apiUrl('/puzzles', true)
      this.puzzlesUrl = this.defaultPuzzlesUrl
    },

    showFilter (ev) {
      this.filter = ev.target.querySelector('input[name=filter]').value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Puzzles.vue